import React from "react";
import "./Help.css";
import { FaLock, FaInfoCircle, FaEnvelope, FaBuilding } from "react-icons/fa";

const HelpPrivacyNotice = () => {
  return (
    <>
<section class="faqSection p-4">
  <div class="container-xl">
    <h2 class="fw-bold mb-4 text-dark">Frequently Asked Questions (FAQs)</h2>

    <div class="faqCategory mb-5">
      <h3 class="fw-semibold text-primary mb-3">Security and Awareness</h3>
      <ul class="list-unstyled">
        <li>What is social engineering?</li>
        <li>How can I prevent social engineering attempts?</li>
        <li>I was recently asked to pay using my gift card over the phone. Is that okay?</li>
        <li>I think I've been scammed. What should I do?</li>
      </ul>
    </div>

    <div class="faqCategory mb-5">
      <h3 class="fw-semibold text-primary mb-3">Extra Facilities</h3>
      <ul class="list-unstyled">
        <li>How do I know if parking is available at the property and how can I reserve it?</li>
        <li>How do I find out if a property has a certain facility (e.g. an elevator)?</li>
        <li>How do I know if the property offers a shuttle service and how can I book it?</li>
        <li>Can the property store my luggage before check-in or after check-out?</li>
      </ul>
    </div>

    <div class="faqCategory mb-5">
      <h3 class="fw-semibold text-primary mb-3">Property Policies</h3>
      <ul class="list-unstyled">
        <li>What if I’m traveling with an assistance animal?</li>
        <li>I want to check out after the stated check-out time. What should I do?</li>
        <li>What are the check-in and check-out times of a property?</li>
        <li>How do I get more info about the facilities available?</li>
        <li>I want a smoking room however I can only choose a non-smoking room. How can I request a smoking room?</li>
        <li>How do I find out if properties allow pets?</li>
        <li>I will be arriving earlier/later than the stated check-in time. Can I still check in?</li>
      </ul>
    </div>

    <div class="faqCategory mb-5">
      <h3 class="fw-semibold text-primary mb-3">Pricing</h3>
      <ul class="list-unstyled">
        <li>Is breakfast included in the price?</li>
        <li>What does the price include?</li>
        <li>Are the prices shown on YOVHO.com per person or per room?</li>
        <li>Are taxes included in the price?</li>
        <li>Do I pay a reservation fee to YOVHO.com?</li>
        <li>What does the crossed out rate mean next to my room type?</li>
        <li>Can I use discount coupons (e.g. issued by magazines, stores, etc.)?</li>
        <li>Does YOVHO.com offer any special discounts or loyalty benefits?</li>
        <li>Do I pay the full price for my child?</li>
      </ul>
    </div>

    <div class="faqCategory mb-5">
      <h3 class="fw-semibold text-primary mb-3">Room Types</h3>
      <ul class="list-unstyled">
        <li>What is the difference between a Double Room and a Twin Room?</li>
        <li>What do "non-refundable" and "free cancellation" mean?</li>
        <li>Can I request an extra bed in my room and will there be an extra charge?</li>
        <li>Is it possible to get an extra bed or crib for a child?</li>
      </ul>
    </div>

    <div class="faqCategory mb-5">
      <h3 class="fw-semibold text-primary mb-3">Communications</h3>
      <ul class="list-unstyled">
        <li>Why does the property's email address end with @property.yovho.com?</li>
      </ul>
    </div>

    <div class="faqCategory mb-5">
      <h3 class="fw-semibold text-primary mb-3">Booking Details</h3>
      <ul class="list-unstyled">
        <li>How do I get more info about the room or property's facilities?</li>
        <li>Is it possible to get an extra bed or crib for a child?</li>
        <li>I can't find my confirmation email. What should I do?</li>
        <li>Will I pay the full price for my children?</li>
        <li>What's the difference between a double room and a twin room?</li>
        <li>I'll be arriving outside check-in hours. Can I still check in?</li>
        <li>Can I make changes to my booking (e.g., change dates)?</li>
      </ul>
    </div>

    <div class="faqCategory mb-5">
      <h3 class="fw-semibold text-primary mb-3">Payment</h3>
      <ul class="list-unstyled">
        <li>Which payment methods are accepted?</li>
        <li>Can I pay with a deposit, or prepayment?</li>
        <li>I was charged. Do I need to do anything?</li>
        <li>Where can I see the payment policy for my booking?</li>
        <li>Why do I need to provide my card details?</li>
        <li>Can I pay for my stay with a different credit card than the one used to book?</li>
        <li>How can I get an invoice?</li>
        <li>Who's going to charge my credit card and when?</li>
      </ul>
    </div>

    <div class="faqCategory mb-5">
      <h3 class="fw-semibold text-primary mb-3">Cancellations</h3>
      <ul class="list-unstyled">
        <li>Can I cancel my booking?</li>
        <li>If I need to cancel my booking, will I pay a fee?</li>
        <li>Can I cancel or change my dates for a non-refundable booking?</li>
        <li>How do I know if my booking was canceled?</li>
        <li>Where can I find my cancellation policy?</li>
      </ul>
    </div>
  </div>
</section>


</>
  );
};

export default HelpPrivacyNotice;
